import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { utils, produce } from 'passiv-libs'
import { HUM, CPI } from 'passiv-api'

const HotWaterModalContainer = ({ render }) => {
  const store = window.__STORE__
  const { hotwater } = store

  const history = useHistory()

  const [state, setState] = useState({
    loading: false,
    modal1: {
      open: false
    },
    modal2: {
      open: false
    }    
  })

  const openModal1 = () => {
    setState(
      produce(draft => {
        draft.modal1.open = true
      })
    )
  }

  const openModal2 = () => {
    setState(
      produce(draft => {
        draft.modal2.open = true
      })
    )
  }

  const ok = async ({ isModal1 }) => {
    setState(
      produce(draft => {
        draft.modal1.open = false
        draft.modal2.open = false
      })
    )
    const settings = {
      ...hotwater.settings,
      preStartLength: hotwater.settings.fullHeatLength,
      noFirePeriod: {
        from: "00:00:00",
        to: "00:00:00"
      }
    }
    await CPI.PUT({
      capability: 'hotwater',
      property: 'hot_water_settings',
      payload: settings
    })
    utils.general.triggerStoreUpdate({
      key: 'hotwater',
      value: { ...store.hotwater, settings }
    })

    if (isModal1) {
      await HUM.PATCH({
        op: 'replace',
        path: '/home/hot_water_schedule_change_timestamp',
        value: new Date().toISOString()
      })
    }
    history.push("/hotwater/control")
  }

  const notNow = async () => {
    setState(
      produce(draft => {
        draft.modal1.open = false
      })
    )
    await HUM.PATCH({
      op: 'replace',
      path: '/home/hot_water_schedule_change_timestamp',
      value: new Date().toISOString()
    })
    history.push("/hotwater")
  }

  const data = {
    ...state,
    modal1: {
      onOpen: openModal1,
      open: state.modal1.open,
      id: 'modal-hot-water-1',
      title: 'Hot water control',
      text: `New improved hot water controls. Please set a hot water schedule to ensure the best experience for you.`,
      tip: false,
      type: 'info',
      buttons: [
        {
          name: 'ok',
          text: 'OK',
          onClick: () => {
            ok({isModal1: true})
          }
        },
        {
          name: 'not-now',
          text: 'Not now',
          onClick: () => {
            notNow()
          }
        }
      ]
      
    },
    modal2: {
      onOpen: openModal2,
      open: state.modal2.open,
      id: 'modal-hot-water-2',
      title: 'Hot water control',
      text: `Are you getting hot water when you need it? Please review your hot water settings.`,
      tip: false,
      type: 'info',
      buttons: [
        {
          name: 'ok',
          text: 'OK',
          onClick: () => {
            ok({isModal1: false})
          }
        }
      ]      
    }
  }

  return render(data)
}

export default HotWaterModalContainer
